import { motion } from 'framer-motion'
import { AlertTriangle, User, Zap } from 'lucide-react'

export default function TurnIndicator({
  currentTurn,
  isMyTurn,
  isCheck,
  playerColor,
  gameActive,
  guestJoined,
  isCreator,
}) {
  if (!gameActive) {
    return (
      <div className="flex items-center gap-4 px-5 py-4 rounded-xl bg-zinc-950 border border-white/5 shadow-inner">
        <div className="w-2 h-2 rounded-full bg-zinc-700 animate-pulse" />
        <span className="text-[11px] font-mono uppercase tracking-[0.15em] text-zinc-500">
          {!guestJoined
            ? 'SYNCHRONIZING: Awaiting Challenger...'
            : isCreator
            ? 'Ready for Engagement — Initialize Match'
            : 'SYSTEM READY: Awaiting Host Command...'}
        </span>
      </div>
    )
  }

  const turnLabel = currentTurn === 'white' ? 'WHITE' : 'BLACK'

  return (
    <div
      className={`relative flex items-center gap-4 px-5 py-4 rounded-xl transition-all duration-500 overflow-hidden ${
        isMyTurn
          ? 'bg-orange-600/10 border border-orange-500/30'
          : 'bg-zinc-950 border border-white/5'
      }`}
    >
      {/* Dynamic Background Effect for Your Turn */}
      {isMyTurn && (
        <motion.div
          animate={{ x: [-200, 400] }}
          transition={{ repeat: Infinity, duration: 2, ease: "linear" }}
          className="absolute inset-0 w-full h-full opacity-10 pointer-events-none"
          style={{
            backgroundImage: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.4) 50%, transparent 100%)'
          }}
        />
      )}

      {/* Turn Indicator Dot */}
      <div className="relative flex items-center justify-center">
        {isMyTurn && (
          <div className="absolute w-5 h-5 bg-orange-600/30 rounded-full animate-ping" />
        )}
        <div
          className={`relative w-2.5 h-2.5 rounded-full ${
            currentTurn === 'white'
              ? 'bg-zinc-100'
              : 'bg-zinc-700'
          }`}
        />
      </div>

      <div className="flex-1 min-w-0 flex items-center gap-2">
        <span className="text-[10px] font-mono text-zinc-600 uppercase tracking-widest hidden md:block">
          STATUS:
        </span>
        {isMyTurn ? (
          <span className="text-sm font-bold tracking-tight text-white flex items-center gap-2">
            <Zap size={14} className="text-orange-500" />
            Active Turn
          </span>
        ) : (
          <span className="text-sm font-mono text-zinc-500 uppercase tracking-wider">
            {turnLabel}
          </span>
        )}
      </div>

      {/* CHECK ALERT */}
      {isCheck && (
        <motion.div 
          animate={{ opacity: [0.3, 1, 0.3] }}
          transition={{ repeat: Infinity, duration: 1 }}
          className="flex items-center gap-1.5 px-3 py-1 rounded bg-red-600/10 border border-red-500/20 text-red-500"
        >
          <AlertTriangle size={12} className="shrink-0" />
          <span className="text-[10px] font-mono font-black uppercase tracking-[0.2em]">Check</span>
        </motion.div>
      )}

      {/* Player Identity Badge */}
      <div className="flex items-center gap-2 bg-zinc-900 border border-white/5 px-3 py-1.5 rounded-md">
        <User size={12} className="text-zinc-600" />
        <span className="text-[10px] font-mono text-zinc-300 uppercase tracking-wider">
          {playerColor === 'white' ? 'White' : 'Black'}
        </span>
      </div>
    </div>
  )
}